export default "__VITE_ASSET__5d06175f__"